import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import request from './utils/request.js'
import 'element-ui/lib/theme-chalk/index.css';
import './utils/element.js'
import './assets/global.css'

Vue.prototype.$http = request

Vue.config.productionTip = false

// 判断是否在小程序web-view内
const isMini = navigator.userAgent.toLowerCase().includes('miniprogram')

if (isMini) {
  // 加载微信sdk
  const script = document.createElement('script')
  script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
  script.onload = () => {
    // 压一条假历史
    history.pushState({}, '', location.href)
    // 监听返回
    window.addEventListener('popstate', function(e) {
      e.preventDefault()
      // 直接关闭web-view页面
      wx.miniProgram.navigateBack({ delta: 1 })
    })
  }
  document.body.appendChild(script)
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
